import React from "react";
import ForgotPasswordForm from "../components/forgotPasswordForm";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function ForgotPasswordPage() {
  return (
    <>
      <Navbar />
      <ForgotPasswordForm />
      <Footer />
    </>
  );
}

export default ForgotPasswordPage;
